import { Guid } from "guid-typescript";

import {
  PossibleChipTypeInfo,
  RawChipItem,
  RawFrontendChipItem
} from "./typedChips.types";

function rawChips(chips: Array<RawFrontendChipItem>) {
  return chips
    .filter(c => c.model !== null)
    .map(c => c.model!)
}

function getChipType(chip: RawChipItem, possibleTypes: PossibleChipTypeInfo) {
  for (const type of Object.keys(possibleTypes)) {
    const typeKey = possibleTypes[type].typeKey;

    if (chip[typeKey] === type) {
      return type;
    }
  }

  return '';
}

function frontendChips(chips: Array<RawChipItem>, possibleTypes: PossibleChipTypeInfo): Array<RawFrontendChipItem> {
  return chips.map((model) => {
    const type = getChipType(model, possibleTypes);
    const info = possibleTypes?.[type];

    return {
      type,
      model,
      info,
      guid: Guid.create().toString()
    };
  });
}

function removeChip(chips: Array<RawFrontendChipItem>, guid: string) {
  return chips.filter(c => c.guid !== guid)
}

function chipExistsByStruct(chips: Array<RawFrontendChipItem>, chipToCheck: RawFrontendChipItem['model']) {
  return chips.some(c => JSON.stringify(c.model) === JSON.stringify(chipToCheck))
}

function updateChip(chips: Array<RawFrontendChipItem>, newChip: RawFrontendChipItem) {
  const chipIdx = chips.findIndex(c => c.guid === newChip.guid)

  chips.splice(chipIdx, 1, newChip)

  return chips
}

function firstFiveSlicedValues(chips: Array<RawFrontendChipItem>) {
  return chips
    .slice(0, 5)
    .map(c => {
      const modelValue = c.model?.value

      if (modelValue && modelValue.length > 51) {
        return `${ modelValue.slice(0, 50) }...`
      }

      return modelValue
    })
}

function defaultTypeOrFirst(possibleTypes: PossibleChipTypeInfo) {
  for (const type of Object.keys(possibleTypes)) {
    if (possibleTypes[type].isDefault) {
      return {
        type,
        config: possibleTypes[type]
      }
    }
  }

  const [ first ] = Object.entries(possibleTypes)

  return { type: first[0], config: first[1] }
}

function frontendChipTemplate(possibleTypes: PossibleChipTypeInfo): RawFrontendChipItem {
  const { type, config } = defaultTypeOrFirst(possibleTypes)

  return {
    guid: Guid.create().toString(),
    info: config,
    type: type,
    model: {
      type,
      value: ''
    }
  }
}

export {
  frontendChipTemplate,
  frontendChips,
  rawChips,
  removeChip,
  updateChip,
  chipExistsByStruct,
  firstFiveSlicedValues,
  defaultTypeOrFirst,
  getChipType
}
